
export default {
  'share': {
    'fullUrl': 'Complète',
    'shortUrl': 'Courte',
    'urlCopied': 'URL copiée dans le presse-papiers.',
    'clickToCopy': 'Cliquez pour copier l\'URL',
    'share': 'Partager (cliquez pour copier)',
    'shareLink': 'Partager le lien',
    'short': 'Raccourcir l\'URL',
    'copyUrlInfo': 'Vous pouvez également copier le lien depuis la barre d\'adresse de votre navigateur.',
    'urlShortened': 'URL courte',
    'shorteningNotPossible': 'Il n\'a pas été possible de générer une URL courte. Veuillez utiliser l\'URL complète',
    'embedCodeCopied': 'Code d\'incorporation copié',
    'embed': 'Incorporation (cliquez pour copier)',
    'embedInstructions': 'Utilisez ce code pour intégrer la carte ORS dans votre site web'
  }
}
